<template>
  <div class="tusd-wrap wrap-bg">
    <div class="err-wrap">
    	<div class="err-img wifi"></div>
    	<div class="err-content">网络异常！</div>
    	<div class="err-operation">
    		<span class="tusd-btn-small" @click="goBack">重新加载</span><br /><br />
    		<span class="tusd-btn-small" @click="goHome">返回首页</span>
    	</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'errPage',
  methods:{
  	goBack(){
  		this.$router.go(-1)
  	},
  	goHome(){
  		this.$router.push({name:'index'})
  	}
  }
}
</script>
